export default __webpack_public_path__ + "static/media/blog2.89133b1a.jpg";